import store from "store"
import getPrivilege from "utils/privileges/privileges"

export const salesEventDetailTransformer = response => {
  const userPrivileges = store.getState()?.app?.privileges
  const noTabData = response?.tabs?.length === 0

  return {
    ...response,
    noTabData,
    SaleEventProjects: {
      visibleItems: response?.SaleEventProjects?.slice(0, 3),
      remainingItems: response?.SaleEventProjects?.slice(3),
    },
    SaleEventCities: {
      visibleItems: response?.SaleEventCities?.slice(0, 3),
      remainingItems: response?.SaleEventCities?.slice(3),
    },
    tabs: response?.tabs?.filter(tab => {
      if (tab.key === "clients") {
        return getPrivilege("can_view_event_clients", userPrivileges)
      }
      if (tab.key === "staff") {
        return getPrivilege("can_view_event_staff", userPrivileges)
      }
      if (tab.key === "insights") {
        return getPrivilege("can_view_event_insights", userPrivileges)
      }
      return true
    }).map(tab => ({
      ...tab,
      count: null,
    })),
  }
}
